import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';
import { useThemedColor } from 'app/hooks/useThemedColors';

import style from './style.scss';

interface Props {
  nbEvents?: number;
}

const CIRCLE_RADIUS = 8;

const MatchListPlaceholder: FC<Props> = ({ nbEvents = 3 }) => {
  const backgroundColor = useThemedColor({
    dark: '#363644',
    light: '#F4F7FA'
  });
  const foregroundColor = useThemedColor({
    dark: '#24242d',
    light: '#E4E6EA'
  });
  return (
    <div>
      {createArray(nbEvents).map((_, index) => (
        <div key={index} className={style.matchContainer}>
          <div className={style.separation} />
          <ContentLoader
            width={950}
            height={90}
            className={style.shapes}
            backgroundColor={backgroundColor}
            foregroundColor={foregroundColor}
          >
            <rect x={34} y={27} width={8} height={8} />
            <rect x={61} y={20} width={22} height={22} />
            <rect x={94} y={25} width={47} height={12} />
            <rect x={154} y={19} width={43} height={23} />
            <rect x={207} y={19} width={81} height={23} />

            <rect x={349} y={23} width={103} height={15} />
            <circle cx={470} cy={30} r={CIRCLE_RADIUS} />

            <circle cx={613} cy={30} r={CIRCLE_RADIUS} />
            <rect x={633} y={23} width={103} height={15} />

            <rect x={31} y={66} width={90} height={8} />
          </ContentLoader>
        </div>
      ))}
    </div>
  );
};

MatchListPlaceholder.displayName = 'MatchListPlaceholder';

export default MatchListPlaceholder;
